import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';
import IconSet34 from '../Icon/IconSet34';
import Flip from 'react-reveal/Flip';
// import Fade from 'react-reveal/Fade';

class SectionDemo extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {containerHeight: '100%'}
  // }

  render() {

    // const barOffset = ['xs', 'sm', 'md'].indexOf(this.props.width) >= 0 ? 120 : 220;
    // const horizontalOffset = ['xs', 'sm', 'md'].indexOf(this.props.width) >= 0 ? 75 : 150;
    const { barOffset, horizontalOffset } = this.props;

    return (
      <section id="example" className="SectionDemo Section" style={this.props.style || {}}>
            <div className="header">

              <SectionCorner length={50} style={{top: 66, marginLeft: 0}} corner={'tl'} color={'#fff'} />
              <SectionBar length={Math.round(barOffset/2+horizontalOffset)-56} style={{top: 56, marginLeft: 56}} color={'#fff'} direction={'horizontal'}/>
              <SectionCorner length={50} style={{marginLeft: ((barOffset-58))}} corner={'bl'} color={'#fff'}/>
            </div>
            <SectionBar length={'calc(100% - 100px)'} style={{top: 50*-1, marginLeft: 0}} color={'#fff'} direction={'vertical'}/>
            <div className="bg"></div>
            <Flip>
              <div className="content">
                <Link to={'/360'}>
                  <Grid container spacing={0}
                    direction="column"
                    justify="space-around"
                    alignItems="center"
                    style={{height: '100%'}}
                    >
                    <Grid item  style={{}}>
                      <IconSet34 icon={'topDemo'} size={34} style={{verticalAlign: 'bottom', width: '34px', height: 34}}/>
                    </Grid>
                    <Grid item >
                      Notre exemple d'un<br />
                    <em>360° candidat</em>
                  </Grid>
                  <Grid item  style={{}}>
                    <IconSet34 icon={'bottomDemo'} size={34} style={{verticalAlign: 'bottom', width: '34px', height: 34}}/>
                  </Grid>
                </Grid>
              </Link>
            </div>
          </Flip>
    </section>
  );
}
}

export default SectionDemo;



// WEBPACK FOOTER //
// ./src/components/Home/SectionDemo.jsx